import { getArticle, getCategories } from '@/graphql/queries/media/article';
import { ldJSON } from '@/scripts/article';

export default async ({ $apolloQuery, app, $dateTime, $railsHost, redirect, route, store }) => {
  const redirectError = () => {
    redirect(301,
      app.localePath(`/blog/${route.params.category}/`),
      { flashClass: 'error', flashMessage: store.$i18n.t('errors.articleNotFound') });
  };
  await $apolloQuery(getCategories).then(categories => store.commit('blog/setCategories', categories));
  await $apolloQuery(getArticle, { slug: route.params.slug }).then(article => {
    if (!article) { return redirectError(); }
    const breadcrumbs = [
      ['i18n/home', '/'],
      ['i18n/blog', '/blog/'],
      [article.category.name, article.category.path],
      article.headline
    ];
    const card = article.image ? (article.image.webp || article.image.fallback) : null;
    const metaTagOptions = { card, description: article.meta_description || article.summary, title: article.meta_title || article.headline };
    route.meta[0] = { ...route.meta[0], ...{ ldJSON: ldJSON(article, $dateTime, $railsHost()), metaTagOptions } };
    store.commit('blog/setArticle', article);
    store.commit('pageContent/setHead', { description: article.summary, title: article.headline });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', breadcrumbs);
  }).catch(_ => redirectError());
};
